<template>
  <div class="px-3 py-2">
    <div v-if="loading" class="text-xs-center mt-3">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
    <div v-else>
      <div class="text-xs-right">
        <v-btn v-if="!isEdit" @click="editdata" small icon outline color="primary">
          <v-icon small>edit</v-icon>
        </v-btn>
      </div>

      <div class="title primary--text">PhytoSmooz</div>
      <v-layout>
        <v-flex xs6 class="pr-1">
          <div class="mb-2">
            <label>เล็ก</label>
            <h5 v-if="!isEdit" class="ma-0">
              <template
                v-if="sessionvalue.product_qouta && sessionvalue.product_qouta.phytosmooz"
                >{{ sessionvalue.product_qouta.phytosmooz.smallbottles | numberFormat }}</template
              >
              <template v-else>0</template>
            </h5>
            <div v-else class="form-control">
              <input type="number" v-model="input.product_qouta.phytosmooz.smallbottles" />
            </div>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-1">
          <div class="mb-2">
            <label>ใหญ่</label>
            <h5 v-if="!isEdit" class="ma-0">
              <template
                v-if="sessionvalue.product_qouta && sessionvalue.product_qouta.phytosmooz"
                >{{ sessionvalue.product_qouta.phytosmooz.bigbottles | numberFormat }}</template
              >
              <template v-else>0</template>
            </h5>
            <div v-else class="form-control">
              <input type="number" v-model="input.product_qouta.phytosmooz.bigbottles" />
            </div>
          </div>
        </v-flex>
      </v-layout>

      <div class="title primary--text mt-3">PhytoMylk</div>
      <v-layout>
        <v-flex xs6 class="pr-1">
          <div class="mb-2">
            <label>เล็ก</label>
            <h5 v-if="!isEdit" class="ma-0">
              <template v-if="sessionvalue.product_qouta && sessionvalue.product_qouta.phytomylk">{{
                sessionvalue.product_qouta.phytomylk.smallbottles | numberFormat
              }}</template
              ><template v-else>0</template>
            </h5>
            <div v-else class="form-control">
              <input type="number" v-model="input.product_qouta.phytomylk.smallbottles" />
            </div>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-1">
          <div class="mb-2">
            <label>ใหญ่</label>
            <h5 v-if="!isEdit" class="ma-0">
              <template v-if="sessionvalue.product_qouta && sessionvalue.product_qouta.phytomylk">{{
                sessionvalue.product_qouta.phytomylk.bigbottles | numberFormat
              }}</template
              ><template v-else>0</template>
            </h5>
            <div v-else class="form-control">
              <input type="number" v-model="input.product_qouta.phytomylk.bigbottles" />
            </div>
          </div>
        </v-flex>
      </v-layout>

      <div class="title primary--text mt-3">PhytoShot</div>
      <v-layout>
        <v-flex xs6 class="pr-1">
          <div class="mb-2">
            <label>ซอท</label>
            <h5 v-if="!isEdit" class="ma-0">
              <template v-if="sessionvalue.product_qouta && sessionvalue.product_qouta.phytoshot">{{
                sessionvalue.product_qouta.phytoshot.smallbottles | numberFormat
              }}</template
              ><template v-else>0</template>
            </h5>
            <div v-else class="form-control">
              <input type="number" v-model="input.product_qouta.phytoshot.smallbottles" />
            </div>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-1">
          <div class="mb-2">
            <label>ใหญ่</label>
            <h5 v-if="!isEdit" class="ma-0">
              <template v-if="sessionvalue.product_qouta && sessionvalue.product_qouta.phytoshot">{{
                sessionvalue.product_qouta.phytoshot.bigbottles | numberFormat
              }}</template
              ><template v-else>0</template>
            </h5>
            <div v-else class="form-control">
              <input type="number" v-model="input.product_qouta.phytoshot.bigbottles" />
            </div>
          </div>
        </v-flex>
      </v-layout>

      <v-divider />
      <div class="mb-2">
        <v-layout class="mt-4" v-if="!isEdit">
          <v-flex xs6>
            <div>Cash Credit</div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <h5 style="font-size: 18px" class="ma-0">{{ sessionvalue.scg | numberFormat }}</h5>
          </v-flex>
        </v-layout>
        <div v-else class="form-control">
          <label>Cash Credit</label>
          <input type="number" v-model="input.scg" />
        </div>
      </div>
      <!-- <div class="mb-2">
        <v-layout v-if="!isEdit">
          <v-flex xs6>
            <div>Inter express</div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <h5 style="font-size: 18px" class="ma-0">
              {{ sessionvalue.interexpress | numberFormat }}
            </h5>
          </v-flex>
        </v-layout>
        <div v-else class="form-control">
          <label>Inter express</label>
          <input type="number" v-model="input.interexpress" />
        </div>
      </div> -->
      <div class="mb-2">
        <v-layout v-if="!isEdit">
          <v-flex xs6>
            <div>Point</div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <h5 style="font-size: 18px" class="ma-0">{{ sessionvalue.point | numberFormat }}</h5>
          </v-flex>
        </v-layout>
        <div v-else class="form-control">
          <label>Point</label>
          <input type="number" v-model="input.point" />
        </div>
      </div>
      <div class="mb-2">
        <v-layout v-if="!isEdit">
          <v-flex xs6>
            <div>Point Expire At</div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <h5 style="font-size: 18px" class="ma-0">
              {{ sessionvalue.pointexpireat | DateFormat('DD/MM/YYYY') }}
            </h5>
          </v-flex>
        </v-layout>
        <div v-else class="form-control">
          <label>Point Expire At</label>
          <DatepickerCustomDialog
            :key="timestamp"
            v-model="input.pointexpireat"
            @input="onchangeDate($event)"
          >
            <template v-slot="{ computedDate }">
              <input
                name="pointexpireat"
                data-vv-as="Point Expire At"
                :value="computedDate"
                readonly
                placeholder="DD/MM/YYYY"
                type="text"
              />
            </template>
          </DatepickerCustomDialog>
        </div>
      </div>

      <div class="mb-2">
        <template v-if="!isEdit">
          <div>Remark</div>
          <div class="ma-0 primary--text">{{ input.remark }}</div>
        </template>
        <div v-else class="form-control">
          <label>Remark</label>
          <textarea v-model="input.remark" />
        </div>
      </div>
      <div v-if="isEdit" class="text-xs-center">
        <v-btn @click="cancelEdit" color="grey" outline>{{ $t('cancel') }}</v-btn>
        <v-btn :loading="saveloading" @click="saveData" color="primary" depressed>{{
          $t('save')
        }}</v-btn>
      </div>
    </div>
    <div v-if="history.length">
      <v-divider class="my-3"></v-divider>
      <h5 style="font-size: 1.4em">Edit History</h5>
      <v-card class="pa-2 mb-2" v-for="(item, index) in history" :key="index">
        <div class="small" style="font-size: small">
          {{ item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}
        </div>
        <v-divider class="my-1"></v-divider>
        <v-layout row wrap class="mb-0">
          <template v-if="item.product_qouta && item.product_qouta.phytosmooz">
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs4 class="caption text-xs-center border-right"> PhytoSmooz </v-flex>
                <v-flex xs4 class="border-right">
                  <div>
                    <div class="caption text-xs-center">เล็ก</div>
                    <div class="text-xs-center" style="font-weight: bold">
                      <span
                        class="red--text"
                        v-if="
                          item.product_qouta.phytosmooz.prev_smallbottles > 0 ||
                          item.product_qouta.phytosmooz.prev_smallbottles < 0
                        "
                        >({{
                          item.product_qouta.phytosmooz.prev_smallbottles | plusAndMinus
                        }})=</span
                      >
                      {{ item.product_qouta.phytosmooz.smallbottles }}
                    </div>
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div>
                    <div class="caption text-xs-center">ใหญ่</div>
                    <div class="text-xs-center" style="font-weight: bold">
                      <span
                        class="red--text"
                        v-if="
                          item.product_qouta.phytosmooz.prev_bigbottles > 0 ||
                          item.product_qouta.phytosmooz.prev_bigbottles < 0
                        "
                        >({{ item.product_qouta.phytosmooz.prev_bigbottles | plusAndMinus }})=</span
                      >
                      {{ item.product_qouta.phytosmooz.bigbottles }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </template>
          <template v-if="item.product_qouta && item.product_qouta.phytomylk">
            <v-flex xs12>
              <v-divider />
            </v-flex>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs4 class="caption text-xs-center border-right"> PhytoMylk </v-flex>
                <v-flex xs4 class="border-right">
                  <div>
                    <div class="caption text-xs-center">เล็ก</div>
                    <div class="text-xs-center" style="font-weight: bold">
                      <span
                        class="red--text"
                        v-if="
                          item.product_qouta.phytomylk.prev_smallbottles > 0 ||
                          item.product_qouta.phytomylk.prev_smallbottles < 0
                        "
                        >({{
                          item.product_qouta.phytomylk.prev_smallbottles | plusAndMinus
                        }})=</span
                      >
                      {{ item.product_qouta.phytomylk.smallbottles }}
                    </div>
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div>
                    <div class="caption text-xs-center">ใหญ่</div>
                    <div class="text-xs-center" style="font-weight: bold">
                      <span
                        class="red--text"
                        v-if="
                          item.product_qouta.phytomylk.prev_bigbottles > 0 ||
                          item.product_qouta.phytomylk.prev_bigbottles < 0
                        "
                        >({{ item.product_qouta.phytomylk.prev_bigbottles | plusAndMinus }})=</span
                      >
                      {{ item.product_qouta.phytomylk.bigbottles }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </template>
          <template v-if="item.product_qouta && item.product_qouta.phytoshot">
            <v-flex xs12>
              <v-divider />
            </v-flex>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs4 class="caption text-xs-center border-right"> PhytoShot </v-flex>
                <v-flex xs8>
                  <div>
                    <div class="caption text-xs-center">ซ็อต</div>
                    <div class="text-xs-center" style="font-weight: bold">
                      <span
                        class="red--text"
                        v-if="
                          item.product_qouta.phytoshot.prev_smallbottles > 0 ||
                          item.product_qouta.phytoshot.prev_smallbottles < 0
                        "
                        >({{
                          item.product_qouta.phytoshot.prev_smallbottles | plusAndMinus
                        }})=</span
                      >
                      {{ item.product_qouta.phytoshot.smallbottles }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </template>
          <template v-if="item.point">
            <v-flex xs12>
              <v-divider />
            </v-flex>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs4 class="caption text-xs-center border-right"> Point </v-flex>
                <v-flex xs8>
                  <div>
                    <div class="text-xs-center" style="font-weight: bold">
                      <span class="red--text" v-if="item.prev_point > 0 || item.prev_point < 0"
                        >({{ item.prev_point | plusAndMinus }})=</span
                      >
                      {{ item.point }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </template>
          <v-flex xs12>
            <v-divider />
          </v-flex>
          <v-flex xs4 class="border-right" v-if="item.other_products">
            <div>
              <div class="caption text-xs-center">Other products</div>
              <div class="text-xs-center" style="font-weight: bold">
                <span
                  class="red--text"
                  v-if="item.prev_other_products_count > 0 || item.prev_other_products_count < 0"
                >
                  ({{ item.prev_other_products_count | plusAndMinus }})=
                </span>
                {{ item.other_products_count }}
              </div>
            </div>
          </v-flex>
          <v-flex xs4 class="border-right">
            <div>
              <div class="caption text-xs-center">Cash Credit</div>
              <div class="text-xs-center" style="font-weight: bold">
                <span class="red--text" v-if="item.prev_scg > 0 || item.prev_scg < 0"
                  >({{ item.prev_scg | plusAndMinus }})=</span
                >
                {{ item.scg }}
              </div>
            </div>
          </v-flex>
          <!-- <v-flex xs4>
              <div>
                <div class="caption text-xs-center">Inter Express</div>
                <div class="text-xs-center" style="font-weight: bold">
                  <span
                    class="red--text"
                    v-if="item.prev_interexpress > 0 || item.prev_interexpress < 0"
                    >({{ item.prev_interexpress | plusAndMinus}})=</span
                  >
                  {{ item.interexpress }}
                </div>
              </div>
            </v-flex> -->
          <v-flex xs12>
            <v-divider />
            Remark
            <v-layout v-if="!item.isEdit">
              <v-flex class="primary--text">
                <nl2br
                  tag="span"
                  :text="item.remark || ''"
                  :title="item.remark || ''"
                  style="word-wrap: break-word"
                />
              </v-flex>
              <v-flex shrink>
                <v-btn @click="item.isEdit = true" small icon outline color="primary">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <div v-else class="form-control">
              <autoresize-textarea :data-vv-as="$t('remark')" name="remark" v-model="item.remark" />
              <div class="text-xs-center">
                <v-btn small depressed color="primary" @click="saveHistory(item)">{{
                  $t('Save')
                }}</v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <div class="caption" v-if="item.created_by">
          Created By {{ item.created_by != value.userid ? item.created_by : 'ลูกค้า' }}
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import moment from 'moment'
import Nl2br from 'vue-nl2br'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    value: {
      default: null
    },
    pageid: {
      default: null
    }
  },
  components: {
    DatepickerCustomDialog,
    Nl2br,
    AutoresizeTextarea
  },
  filters: {
    plusAndMinus(val) {
      if (val > 0) {
        return `+${val}`
      } else {
        return val
      }
    }
  },
  data() {
    return {
      historyloading: false,
      saveloading: false,
      sessionvalue: '',
      loading: false,
      isEdit: false,
      history: [],
      input: {
        product_qouta: {
          phytomylk: {
            bigbottles: 0,
            smallbottles: 0
          },
          phytosmooz: {
            bigbottles: 0,
            smallbottles: 0
          },
          phytoshot: {
            bigbottles: 0,
            smallbottles: 0
          }
        },
        scg: 0,
        interexpress: 0,
        hub: 0,
        remark: ''
      },
      currentpageid: null,
      timestamp: moment().format('x')
    }
  },
  async mounted() {
    if (this.pageid) {
      this.currentpageid = this.pageid
    } else {
      this.currentpageid = this.selectedBot.pageid
    }
    await this.getUser()
    this.getHistory()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onchangeDate(date) {
      // console.log(date)
    },
    async saveHistory(item) {
      var id = item.id
      var json = cloneDeep(item)
      delete json.id
      var vm = this

      api.putnvbbquotahistory(
        {
          params: {
            pageid: vm.selectedBot.pageid,
            userid: vm.value.userid
          },
          body: {
            id: id,
            sessionvalue: JSON.stringify(json)
          }
        },
        (error, response) => {
          // console.log(response)
          if (response && response.responsecode == 200) {
            vm.$set(item, 'isEdit', false)
          }
        }
      )
    },
    getHistory() {
      api.getnvbbquotahistory(
        { pageid: this.currentpageid, userid: this.value.userid },
        (error, response) => {
          if (response.responsecode == 200) {
            if (response.data) {
              this.history = response.data.map((el, index) => {
                var history = {}
                try {
                  history = JSON.parse(el.sessionvalue)
                  history.id = el.id
                  history.other_products_count =
                    history && history.other_products ? history.other_products.length : 0
                  history.isEdit = false
                  history.created_by = el.created_by
                } catch (error) {
                  //
                }
                try {
                  if (response.data[index + 1]) {
                    var next_history = JSON.parse(response.data[index + 1].sessionvalue)

                    history.prev_other_products_count =
                      history.other_products_count -
                      (next_history.other_products ? next_history.other_products.length : 0)

                    history.prev_scg = (history.scg || 0) - (next_history.scg || 0)
                    history.prev_interexpress =
                      (history.interexpress || 0) - (next_history.interexpress || 0)
                    history.prev_point = (history.point || 0) - (next_history.point || 0)
                    if (history.product_qouta && next_history.product_qouta) {
                      for (const key in history.product_qouta) {
                        if (Object.hasOwnProperty.call(history.product_qouta, key)) {
                          const element = history.product_qouta[key]
                          const next_element = next_history.product_qouta[key]
                          element.prev_bigbottles =
                            (element.bigbottles || 0) - (next_element.bigbottles || 0)
                          element.prev_smallbottles =
                            (element.smallbottles || 0) - (next_element.smallbottles || 0)
                        }
                      }
                    }
                  }
                } catch (error) {}
                return { ...history, timestamp: el.timestamp }
              })
            }
          }
        }
      )
    },
    cancelEdit() {
      this.isEdit = false
    },
    saveData() {
      this.saveloading = true
      var obj = { ...this.input }
      for (var item in this.input) {
        if (item == 'pointexpireat') {
          obj[item] = this.input[item]
        }
      }

      var data = {
        pageid: this.currentpageid,
        usersid: this.value.userid,
        sessionvalue: JSON.stringify(obj)
      }
      api.putusersessionvalue(data, (err, response) => {
        this.saveloading = false
        this.sessionvalue = { ...this.input }
        this.input.remark = ''
        this.isEdit = false
        this.getHistory()
      })
    },
    getUser() {
      return new Promise((resolve) => {
        this.loading = true
        var data = {
          pageid: this.currentpageid,
          userid: this.value.userid
        }
        api.getUserOnly(data, (err, response) => {
          if (response.responsecode == 200 && response.data) {
            let sessionvalue = {
              product_qouta: {
                phytomylk: {
                  bigbottles: 0,
                  smallbottles: 0
                },
                phytosmooz: {
                  bigbottles: 0,
                  smallbottles: 0
                },
                phytoshot: {
                  bigbottles: 0,
                  smallbottles: 0
                }
              },
              scg: 0,
              interexpress: 0,
              hub: 0,
              remark: ''
            }
            try {
              let parse_sessionvalue = JSON.parse(response.data[0].sessionvalue)

              sessionvalue = {
                ...sessionvalue,
                ...parse_sessionvalue
              }

              if (!sessionvalue.product_qouta) {
                sessionvalue.product_qouta = {}
              }

              if (!sessionvalue.product_qouta.phytomylk)
                sessionvalue.product_qouta.phytomylk = {
                  bigbottles: 0,
                  smallbottles: 0
                }

              if (!sessionvalue.product_qouta.phytosmooz)
                sessionvalue.product_qouta.phytosmooz = {
                  bigbottles: 0,
                  smallbottles: 0
                }
              if (!sessionvalue.product_qouta.phytoshot)
                sessionvalue.product_qouta.phytoshot = {
                  bigbottles: 0,
                  smallbottles: 0
                }
            } catch (error) {
              console.log(error)
            } finally {
              this.sessionvalue = sessionvalue
            }
          }
          this.loading = false
          resolve()
        })
      })
    },
    editdata() {
      this.input = { ...this.sessionvalue }
      if (this.sessionvalue.pointexpireat) {
        // console.log(this.sessionvalue.pointexpireat)
        this.$set(
          this.input,
          'pointexpireat',
          moment(this.sessionvalue.pointexpireat).format('YYYY-MM-DD HH:mm')
        )
        this.timestamp = moment().format('x')
      }
      this.input.remark = ''
      this.isEdit = true
    }
  },
  watch: {
    value: async function (newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        await vm.getUser()
        vm.history = []
        vm.getHistory()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/NvbbQuota.vue